import palette from './palette';
import app from './app';

const token = {
  ...app.token,
  // -- rewrite token for the public app
  colorBgBase: palette.acastYellowLight,
  colorLink: palette.acastBlack,
  colorBgLayout: palette.acastYellowLight,
  colorBorder: palette.acastBlack,
  colorErrorBorder: palette.acastRedMid,
  colorInfoBg: palette.acastPurpleGrey,
  colorLinkActive: palette.acastBlack,
  colorLinkHover: palette.acastBlack,
  colorPrimaryBorder: palette.acastBlack,
  colorPrimaryBorderHover: palette.acastBlack,
  colorPrimaryHover: palette.acastBlack,
  colorWarningBorder: palette.acastOrange,
};

const components = {};

const theme = { token, components };

export default theme;
